import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const concatenate = (first, second) => {
    async function* iterator() {
        yield* first;
        yield* second;
    }
    return new BasicAsyncEnumerable(iterator);
};
